import {lorem} from "./Utils";
import {ASSETS, DEBUG, ORDER, MAX_YEAR, MIN_YEAR} from "./Constants";

export default function template() {
	return `
	<div id="graphic">
		<div id="ui">
			<div id="legend">
				<div id="scale"></div>
			</div>
			<div id="tooltip">
				<div class="tooltip"></div>
			</div>
		</div>
		<!-- canvas -->
			<div id="map" ${DEBUG ? `class="debug"` : ``}>
				<div id="pane">
					<div class="caption"></div>
				</div>
				${DEBUG ? `<div id="debug"></div>` : ``}
				<div id="underlay"><div id="axes"></div></div>
				<div id="overlay">
					<div id="labels"></div>
					<div id="labels1"></div>
					<div id="labels2"></div>
				</div>
			</div>
			<div id="sections">
			
			<section class="step" data-step="95"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}" >
				<p>In this scatterplot, each square represents a country. A square’s placement indicates the level of restrictions in that country on our <strong>Government Restrictions Index</strong> (GRI) and our <strong>Social Hostilities Index</strong> (SHI). The color of each square represents the corresponding country’s region of the world. Hover over each square to see the scores and levels of restrictions.</p>
			</section>
			<section class="step" data-step="96"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}">
<p>In 2023, Israel, Pakistan and Syria had “very high” levels of religion-related restrictions on both the GRI and SHI.</p>
<p>In Pakistan, <a href="https://www.state.gov/reports/2023-report-on-international-religious-freedom/pakistan/">the government arrested 140 people on charges of blasphemy</a> relating to social media posts</a>. And leaders of religious minority groups such as Ahmadi Muslims, Christians, Hindus and Sikhs said members of their groups faced discrimination from the government.</p>
<p>The country’s SHI went up because armed sectarian groups carried out bombings against religious targets, including a mosque (over 100 deaths, in January) and a Sunni Muslim procession (over 50 deaths, in September.)</p>
<p>Israel’s SHI score rose in part due to the <a href="https://www.state.gov/reports/2023-report-on-international-religious-freedom/israel-west-bank-and-gaza/">Oct. 7 attacks in the country by Hamas and other militant groups</a>, which led to about 1,200 deaths that day and over 200 kidnappings. Also, Christian leaders in Israel said there were increased attacks against their clergy and property by Jewish extremist organizations.</p>
<p>Israel’s GRI score reflected restricted access (by its security forces) to the Haram al-Sharif/Temple Mount, a site significant to both Muslims and Jews, after Oct. 7. And earlier in the year, Israeli police forcibly entered al-Aqsa mosque twice during the month of Ramadan to disperse large crowds of worshipers. The police used stun grenades and other force to enter the mosque and disperse people they said were rioters. </p>

			</section>
			<section class="step" data-step="97"  data-layout="scatter"  data-center="760" data-min_year="2007" data-max_year="${MAX_YEAR}" >
				<p>Each country’s GRI and SHI scores are calculated annually to reflect events that occurred <em>in that country</em>. Between 2007 and ${MAX_YEAR}, for example, Syria’s GRI and SHI scores were “moderate,” “high” or “very high,” as shown in the accompanying graphic.</p>
			</section>
			<section class="step" data-step="98"  data-layout="global_scatter" data-min_year="${MAX_YEAR}" data-max_year="${MAX_YEAR}" >
				<div><p>To view levels of religious restrictions in any of the almost 200 countries and territories included in the study, use the search bar or select a square from the scatterplot by clicking on it.</p></div>
				<div class="close">${this.renderDropdown()}</div>
				<div class="country-info"></div>
				<div class="ui basic buttons"><div class="ui button active year">${MAX_YEAR}</div><div class="ui button trend">${MIN_YEAR}-${MAX_YEAR} trend</div></div>
			</section>
				<!--End-->

			</div><!-- /sections -->
		</div><!-- /graphic -->
	`;
}
